import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { abortController } from 'store/utils';
import { createEmirateApi, deleteEmirateApi, editEmirateApi, getEmirateApi, getRegionsApi } from './api';
const initialState = {
    emirates: [],
    emirate: undefined,
    selected: undefined,
};
const actions = {
    setSelected: (emirate, { setState }) => {
        try {
            setState((state) => {
                state.selected = emirate;
            });
        }
        catch (err) {
            const error = err;
            throw error.response?.data.message;
        }
    },
    addEmirate: (emirate, { setState }) => {
        try {
            setState((state) => {
                state.emirates.push(emirate);
            });
        }
        catch (err) {
            const error = err;
            throw error.response?.data.message;
        }
    },
    getEmirates: async (_, { setState }) => {
        try {
            const { data } = await getRegionsApi();
            setState((state) => {
                state.emirates = data;
            });
            return data;
        }
        catch (err) {
            const error = err;
            throw error.response?.data.message;
        }
    },
    getEmirate: async (payload, { setState }) => {
        try {
            const { data } = await getEmirateApi(payload);
            setState((state) => {
                state.emirate = data;
            });
            return data;
        }
        catch (err) {
            const error = err;
            throw error.response?.data.message;
        }
    },
    createEmirate: async (payload, { setState }) => {
        try {
            const { data } = await createEmirateApi(payload);
            setState((state) => {
                state.emirates.push(data);
            });
            return data;
        }
        catch (err) {
            const error = err;
            throw error.response?.data;
        }
    },
    editEmirate: async (payload, { setState }) => {
        try {
            const { data } = await editEmirateApi(payload);
            setState((state) => {
                const emirateIndex = state.emirates.findIndex(({ id }) => id === data.id);
                state.emirates[emirateIndex] = data;
            });
            return data;
        }
        catch (err) {
            const error = err;
            throw error.response?.data;
        }
    },
    deleteEmirate: async (payload, { setState }) => {
        try {
            const { data } = await deleteEmirateApi(payload);
            setState((state) => {
                state.emirates = state.emirates.filter(({ id }) => id !== payload.id);
            });
            return data;
        }
        catch (err) {
            const error = err;
            throw error.response?.data;
        }
    },
};
const store = { ...initialState, ...actions };
export default create()(devtools(immer((set, get) => abortController(store, set, get, 'Emirates')), { name: 'Emirates' }));
